module.exports = (__parcel__import__("./" + require('./helpers/bundle-manifest').resolve("4VRTt"))).then(() => parcelRequire('gMQ2m'));